import React from 'react';
import IframeComm from 'react-iframe-comm';
import { compose, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { commonStyles } from '../../styles/styles';
import { connect } from 'react-redux';
import { xapiRequest } from '../../redux/reducers/xapi';
import { CookiesProvider, Cookies } from 'react-cookie';
const cookies = new Cookies();

const LearnerThinkToolView = ({ classes, pathForIFrame, onReceiveMessage, onClose }) => {
  const attributes = {
    src: pathForIFrame,
    width: '100%',
    height: '100%',
  };

  const getParameterByName = (name) => {
      var queryStringFromStartOfValue = window.location.search.split(name + '=')[1];
      return queryStringFromStartOfValue !== undefined ? queryStringFromStartOfValue.split('&')[0] : null;
      }
  return (
    <div style={{position:'absolute', top:0, left:0, right:0, bottom:30, zIndex:10000}}>
      <div className={classes.thinkTool}>
        {pathForIFrame && (
          <div style={{height: '100%', width: '100%'}}>
            <IframeComm attributes={attributes} handleReceiveMessage={onReceiveMessage} />

            {cookies.get('loginAs') && cookies.get('loginAs')==1 && cookies.get('loginType')==0 && (<><div style={{
        margin: 0,
        top:0,
        left:0,
        height: '100vh',
        width: '100vw',
        position: 'absolute',
        fontFamily: 'Arial, sans-serif'
      }}>

              {/* Semi-transparent overlay */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(255, 255, 255, 0.3)',
                zIndex: 1
              }} />
              {/* Read-only box */}
              <div style={{
                position: 'absolute',
                top: 20,
                right: 20,
                backgroundColor: 'white',
                borderRadius: 5,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                zIndex: 2,
                padding: '10px 15px',
                textAlign: 'center'
              }}>
                <div style={{
                  fontWeight: 'bold',
                  color: '#007acc',
                  marginBottom: 8,
                  fontSize: 14
                }}>
                  Read only
                </div>
                <button
                  onClick={() => onClose()}
                  style={{
                    backgroundColor: '#007acc',
                    color: 'white',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: 4,
                    cursor: 'pointer'
                  }}
                >
                  CLOSE
                </button>
              </div>
            </div></>)}
          </div>
        )}
      </div>
    </div>
  );
};

LearnerThinkToolView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  pathForIFrame: PropTypes.string,
  onReceiveMessage: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
});


const mapDispatchToProps = dispatch => ({
  
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),

});

export default compose(connect(
  null,
  mapDispatchToProps,
),lifecycle({
  componentWillMount(){
  
      // xapiRequest({ xapiType: `Opened`});

  },
  componentWillUnmount(){

  }
}),withStyles(styles),)(LearnerThinkToolView);
